/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { events } from '@adobe-commerce/event-bus';
import {
  fetchGraphQl,
  removeFetchGraphQlHeader,
  setFetchGraphQlHeader,
} from '../fetch-graphql';
import { deleteCookie, getCookie } from '@/auth/lib/cookieUtils';
import { COOKIE_NAMES } from '@/auth/configs/cookieConfigs';
import { VALIDATE_CUSTOMER_TOKEN } from './graphql/verifyToken.graphql';
import { emitAuthGroupIdEvent } from '@/auth/lib/emitAuthGroupId';

export const verifyToken = async (
  authType = 'Authorization',
  type = 'Bearer'
) => {
  const token = getCookie(COOKIE_NAMES.auth_dropin_user_token);

  if (!token) {
    await emitAuthGroupIdEvent();
    events.emit('authenticated', false);
    return false;
  }

  setFetchGraphQlHeader(authType, `${type} ${token}`);

  return fetchGraphQl(VALIDATE_CUSTOMER_TOKEN).then(async (res) => {
    const unauthenticated = !!res.errors?.find(
      (error) => error.extensions?.category === 'graphql-authentication'
    );

    if (!unauthenticated) {
      await emitAuthGroupIdEvent(res.data?.customer?.group?.uid);
      events.emit('authenticated', true);
      return true;
    };

    deleteCookie(COOKIE_NAMES.auth_dropin_user_token);
    removeFetchGraphQlHeader(authType);
    await emitAuthGroupIdEvent();
    events.emit('authenticated', false);
    return false;
  });
};
